module.exports = __webpack_public_path__ + "static/media/search-2.49ad7740.png";